module.exports = __webpack_public_path__ + "img/sergeant-reason-icon8.2f50aafd.png";